import React, { useEffect, useState } from 'react';
import { axios } from '../../config';
import M from 'materialize-css';
import './index.css';

const SeguimientoTransferencias = () => {
    const [pedidos, setPedidos] = useState([]);
    const [loader, setLoader] = useState(true);
    const [selectedPedido, setSelectedPedido] = useState(null);
    const [filtroStatus, setFiltroStatus] = useState('Todos');
    const [showModal, setShowModal] = useState(false);
    const [nuevoStatus, setNuevoStatus] = useState('');
    const [notas, setNotas] = useState('');

    useEffect(() => {
        fetchPedidos();
        M.AutoInit();
    }, []);

    const fetchPedidos = async () => {
        try {
            setLoader(true);
            const response = await axios.get('/api/pedidos_transferencia');
            setPedidos(response.data);
            setLoader(false);
        } catch (error) {
            console.error('Error al cargar pedidos:', error);
            M.toast({ html: 'Error al cargar pedidos', classes: 'red' });
            setLoader(false);
        }
    };

    const calcularTotal = (pedido) => {
        const subtotal = pedido.articulos?.reduce((acc, art) => 
            acc + (parseFloat(art.precio) * parseInt(art.cantidad)), 0
        ) || 0;
        const envio = parseFloat(pedido.total_envio) || 0;
        return (subtotal + envio).toFixed(2);
    };

    const abrirDetalles = (pedido, pedido_envio) => {
        setSelectedPedido({...pedido, envio: [pedido_envio]});
        setNuevoStatus(pedido_envio.status || '');
        setShowModal(true);
    };

    const cerrarModal = () => {
        setShowModal(false);
        setSelectedPedido(null);
        setNuevoStatus('');
        setNotas('');
    };

    const actualizarStatus = async () => {
        if (!nuevoStatus) {
            M.toast({ html: 'Selecciona un status', classes: 'orange' });
            return;
        }

        try {
            await axios.post(`/api/change_status_pedido_envio_shop_api`, {
                status: nuevoStatus,
                pedido_envio_id: selectedPedido.envio[0].id,
                notas: notas
            });
            M.toast({ html: 'Status actualizado correctamente', classes: 'green' });
            fetchPedidos();
            cerrarModal();
        } catch (error) {
            console.error('Error al actualizar status:', error);
            M.toast({ html: 'Error al actualizar status', classes: 'red' });
        }
    };

    const marcarComoPagado = async (pedidoId) => {
        if (!window.confirm('¿Confirmas que este pedido ha sido pagado?')) return;

        try {
            await axios.post(`/api/pagar_pedido_envio`, { pedido_id: pedidoId });
            M.toast({ html: 'Pedido marcado como pagado', classes: 'green' });
            fetchPedidos();
        } catch (error) {
            console.error('Error:', error);
            M.toast({ html: 'Error al marcar como pagado', classes: 'red' });
        }
    };

    const pedidosFiltrados = pedidos.filter(pedido => {
        if (filtroStatus === 'Todos') return true;
        return pedido.status === filtroStatus;
    });

    const getStatusBadge = (status) => {
        const statusConfig = {
            'Pendiente de pago': { color: 'orange', icon: 'schedule' },
            'Pagado': { color: 'green', icon: 'check_circle' },
            'En proceso de importación': { color: 'blue', icon: 'local_shipping' },
            'En tránsito': { color: 'purple', icon: 'flight' },
            'En aduana': { color: 'amber', icon: 'gavel' },
            'Listo para entrega': { color: 'teal', icon: 'inventory' },
            'Entregado': { color: 'green darken-2', icon: 'done_all' },
            'Cancelado': { color: 'red', icon: 'cancel' }
        };

        const config = statusConfig[status] || { color: 'grey', icon: 'help' };
        return (
            <span className={`status-badge ${config.color}`}>
                <i className="material-icons tiny">{config.icon}</i>
                {status}
            </span>
        );
    };

    if (loader) {
        return (
            <div className="st-loader-container">
                <div className="preloader-wrapper big active">
                    <div className="spinner-layer spinner-blue-only">
                        <div className="circle-clipper left">
                            <div className="circle"></div>
                        </div>
                        <div className="gap-patch">
                            <div className="circle"></div>
                        </div>
                        <div className="circle-clipper right">
                            <div className="circle"></div>
                        </div>
                    </div>
                </div>
                <p>Cargando pedidos...</p>
            </div>
        );
    }

    return (
        <div className="st-container">
            {/* Header */}
            <div className="st-header">
                <div className="st-header-content">
                    <div className="st-header-title">
                        <i className="material-icons">assignment_turned_in</i>
                        <div>
                            <h4>Seguimiento de Pedidos Mayoristas</h4>
                            <p>Gestión de transferencias e importaciones</p>
                        </div>
                    </div>
                    <button className="btn blue waves-effect" onClick={fetchPedidos}>
                        <i className="material-icons left">refresh</i>
                        Actualizar
                    </button>
                </div>
            </div>

            {/* Filtros */}
            <div className="st-filters">
                <div className="st-filter-chips">
                    {['Todos', 'Pendiente de pago', 'Pagado'].map(status => (
                        <div
                            key={status}
                            className={`chip ${filtroStatus === status ? 'active' : ''}`}
                            onClick={() => setFiltroStatus(status)}
                        >
                            {status}
                            <span>
                                {status === 'Todos' 
                                    ? pedidos.length 
                                    : pedidos.filter(p => p.status === status).length
                                }
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            {/* Estadísticas */}
            <div className="st-stats">
                <div className="st-stat-card">
                    <i className="material-icons">schedule</i>
                    <div>
                        <h5>{pedidos.filter(p => p.status === 'Pendiente de pago').length}</h5>
                        <p>Pendientes de pago</p>
                    </div>
                </div>
                <div className="st-stat-card">
                    <i className="material-icons">check_circle</i>
                    <div>
                        <h5>{pedidos.filter(p => p.status === 'Pagado').length}</h5>
                        <p>Pagados</p>
                    </div>
                </div>
                <div className="st-stat-card">
                    <i className="material-icons">local_shipping</i>
                    <div>
                        <h5>{pedidos.filter(p => p.envio.some(e=>e.status==='Enviado')).length}</h5>
                        <p>Enviados</p>
                    </div>
                </div>
                <div className="st-stat-card">
                    <i className="material-icons">attach_money</i>
                    <div>
                        <h5>${pedidos.reduce((acc, p) => acc + parseFloat(calcularTotal(p)), 0).toFixed(2)}</h5>
                        <p>Total en pedidos</p>
                    </div>
                </div>
            </div>

            {/* Lista de Pedidos */}
            <div className="st-pedidos-list">
                {pedidosFiltrados.length === 0 ? (
                    <div className="st-empty-state">
                        <i className="material-icons">inbox</i>
                        <h5>No hay pedidos</h5>
                        <p>No se encontraron pedidos con los filtros seleccionados</p>
                    </div>
                ) : (
                    pedidosFiltrados.map(pedido => {
                        const proveedor = pedido.envio[0]?.paquete?.productos[0]?.proveedor;
                        const envio = pedido.envio[0];
                        
                        return (
                            <div key={pedido.id} className="st-pedido-card">
                                <div className="st-pedido-header">
                                    <div className="st-pedido-info">
                                        <div className="st-pedido-id">
                                            <i className="material-icons">receipt</i>
                                            <span>Pedido #{pedido.id}</span>
                                        </div>
                                        <div className="st-pedido-fecha">
                                            {new Date(pedido.created_at).toLocaleDateString('es-MX', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })}
                                        </div>
                                    </div>
                                    {getStatusBadge(pedido.status)}
                                </div>

                                <div className="st-pedido-body">
                                    {/* Cliente */}
                                    <div className="st-info-section">
                                        <div className="st-info-header">
                                            <i className="material-icons blue-text">person</i>
                                            <h6>Cliente</h6>
                                        </div>
                                        <div className="st-info-content">
                                            <p><strong>{envio?.nombre}</strong></p>
                                            <p><i className="material-icons tiny">phone</i> {envio?.telefono}</p>
                                            <a 
                                            href={`https://wa.me/${envio?.telefono?.replace(/\D/g, '')}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn-small green darken-2 waves-effect"
                                        >
                                            <i className="material-icons left">whatsapp</i>
                                            WhatsApp
                                        </a>
                                            <p><i className="material-icons tiny">email</i>
                                            <a href={`mailto:${envio?.correo}`}>
                                            {envio?.correo}
                                            </a>
                                            </p>
                                            <p className="st-direccion">
                                                <i className="material-icons tiny">place</i>
                                                {envio?.calle} {envio?.numExt}, {envio?.colonia}, {envio?.ciudad}, {envio?.estado}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Proveedor */}
                                    <div className="st-info-section">
                                        <div className="st-info-header">
                                            <i className="material-icons purple-text">store</i>
                                            <h6>Proveedor</h6>
                                        </div>
                                        <div className="st-info-content">
                                            <p><strong>{proveedor?.company_name}</strong></p>
                                            <p><i className="material-icons tiny">person</i> {proveedor?.contact_persons[0]?.name}</p>
                                            <p><i className="material-icons tiny">phone</i> {proveedor?.contact_persons[0]?.telephone}</p>
                                            <a 
                                            href={`https://wa.me/${proveedor?.contact_persons[0]?.telephone?.replace(/\D/g, '')}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn-small green darken-2 waves-effect"
                                        >
                                            <i className="material-icons left">whatsapp</i>
                                            WhatsApp
                                        </a>
                                            <p>
                                                <i className="material-icons tiny">email</i>
                                                <a href={`mailto:${proveedor?.contact_persons[0]?.email}`}>
                                                    {proveedor?.contact_persons[0]?.email}
                                                </a>
                                                
                                            </p>
                                        </div>
                                    </div>

                                     
                                     {/* Pedido Envios */}
                                    <div className="st-info-section full-width">
                                        <div className="st-info-header">
                                            <i className="material-icons orange-text">inventory_2</i>
                                            <h6>Pedido Envios ({pedido.envio?.length || 0})</h6>
                                        </div>
                                        {pedido.envio.map(pedido_envio =>
                                        <div className="st-productos-list">
                                            {/* Productos */}
                                            {pedido_envio.paquete.productos?.slice(0, 3).map((articulo, idx) => (
                                                <div key={idx} className="st-producto-item">
                                                    <img 
                                                        src={articulo.imagenes[0]?.url || '/noPhoto.png'} 
                                                        alt={articulo.nombre}
                                                        onError={(e) => e.target.src = '/noPhoto.png'}
                                                    />
                                                    <div className="st-producto-info">
                                                        <p className="st-producto-nombre">{articulo.nombre}</p>
                                                        <p className="st-producto-cantidad">
                                                            Cantidad: {articulo.cantidad} × ${articulo.precio}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                            {pedido_envio.paquete.productos?.length > 3 && (
                                                <p className="st-mas-productos">
                                                    +{pedido.articulos.length - 3} productos más
                                                </p>
                                            )}
                                            <button 
                                            className="btn-small blue waves-effect"
                                            onClick={() => abrirDetalles(pedido, pedido_envio)}
                                        >
                                            <i className="material-icons left">visibility</i>
                                            Ver Detalles
                                        </button>
                                        </div>
                                        )}
                                    </div>

                                    {/* Servicios Asiamart */}
                                    {envio?.servicio === 'Servicios Asiamart' && (
                                        <div className="st-info-section full-width">
                                            <div className="st-info-header">
                                                <i className="material-icons teal-text">verified</i>
                                                <h6>Servicios de Importación</h6>
                                            </div>
                                            <div className="st-info-content">
                                                <p className="st-servicios-descripcion">{envio.descripcion}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="st-pedido-footer">
                                    <div className="st-pedido-total">
                                        <div className="st-total-breakdown">
                                            <span>Subtotal:</span>
                                            <span>${pedido.articulos?.reduce((acc, art) => 
                                                acc + (parseFloat(art.precio) * parseInt(art.cantidad)), 0
                                            ).toFixed(2)}</span>
                                        </div>
                                        <div className="st-total-breakdown">
                                            <span>Envío/Servicios:</span>
                                            <span>${parseFloat(pedido.total_envio).toFixed(2)}</span>
                                        </div>
                                        <div className="st-total-final">
                                            <span>Total:</span>
                                            <span>${calcularTotal(pedido)}</span>
                                        </div>
                                    </div>
                                    <div className="st-pedido-actions">
                                        {pedido.status === 'Pendiente de pago' && (
                                            <button 
                                                className="btn-small green waves-effect"
                                                onClick={() => marcarComoPagado(pedido.id)}
                                            >
                                                <i className="material-icons left">check</i>
                                                Marcar Pagado
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>

            {/* Modal de Detalles */}
            {showModal && selectedPedido && (
                <div className="st-modal-overlay" onClick={cerrarModal}>
                    <div className="st-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="st-modal-header">
                            <h5>Gestionar Pedido #{selectedPedido.id}</h5>
                            <button className="btn-flat" onClick={cerrarModal}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="st-modal-body">
                            <div className="st-modal-section">
                                <label>Cambiar Status</label>
                                <select 
                                    className="browser-default st-select"
                                    value={nuevoStatus}
                                    onChange={(e) => setNuevoStatus(e.target.value)}
                                >
                                    <option value="">Selecciona un status</option>
                                    <option value="Pendiente">Pendiente</option>
                                    <option value="Enviado">Enviado</option>
                                    <option value="Entregado">Entregado</option>
                                </select>
                            </div>

                            {/*<div className="st-modal-section">
                                <label>Notas / Observaciones</label>
                                <textarea
                                    className="materialize-textarea"
                                    value={notas}
                                    onChange={(e) => setNotas(e.target.value)}
                                    placeholder="Agrega notas sobre este cambio de status..."
                                    rows="4"
                                />
                            </div>*/}

                            <div className="st-modal-section">
                                <h6>Información del Pedido</h6>
                                <div className="st-modal-info-grid">
                                    <div>
                                        <strong>Fecha de creación:</strong>
                                        <p>{new Date(selectedPedido.created_at).toLocaleString('es-MX')}</p>
                                    </div>
                                    <div>
                                        <strong>Método de pago:</strong>
                                        <p>{selectedPedido.metodo_pago}</p>
                                    </div>
                                    <div>
                                        <strong>Status actual:</strong>
                                        <p>{selectedPedido.status}</p>
                                    </div>
                                    <div>
                                        <strong>Total:</strong>
                                        <p className="green-text text-darken-2">
                                            ${calcularTotal(selectedPedido)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="st-modal-footer">
                            <button className="btn grey waves-effect" onClick={cerrarModal}>
                                Cancelar
                            </button>
                            <button className="btn blue waves-effect" onClick={actualizarStatus}>
                                <i className="material-icons left">save</i>
                                Actualizar Status
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SeguimientoTransferencias;